var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('div',{staticClass:"main-container layout"},[_c('navbar'),_c('IAside',{staticClass:"sidebar-container"}),_c('TagsView',{staticClass:"tags"}),_c('RescuePopup'),_c('div',{staticClass:"ud-content"},[_c('app-main')],1),_c('footer',{staticClass:"ud-footer"},[_vm._v("©版权所有 浙江春风动力股份有限公司")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }